import { Security } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import 'semantic-ui-css/semantic.min.css';
import AppContainer from './components/App/AppContainer';
import './css/styles.css';
import { oktaAuth } from './lib/Authentication/AuthenticationService';
import store from './redux/store';
import * as serviceWorker from './serviceWorker';

// Suppress known React 18 deprecation warnings from semantic-ui-react (findDOMNode, defaultProps)
if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  const originalError = console.error;
  console.error = (...args: unknown[]) => {
    const msg = typeof args[0] === 'string' ? args[0] : String(args[0]);
    if (msg.includes('findDOMNode') || msg.includes('defaultProps will be removed')) {
      return;
    }
    originalError.apply(console, args);
  };
}

function OktaSecurityWrapper({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const restoreOriginalUri = (_oktaAuth: unknown, originalUri: string) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin));
  };
  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  );
}

const domTarget = document.getElementById('root');
if (domTarget) {
  const root = createRoot(domTarget);
  root.render(
    <Provider store={store}>
      <BrowserRouter>
        <OktaSecurityWrapper>
          <AppContainer />
        </OktaSecurityWrapper>
      </BrowserRouter>
    </Provider>
  );
}

serviceWorker.unregister();
